import { GET_SOLAR_PRODUCTS_AVAILABILITY_API } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(`${GET_SOLAR_PRODUCTS_AVAILABILITY_API}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        latitude: requestBody.latitude,
        longitude: requestBody.longitude,
        address: requestBody.address,
        productList: requestBody.productList,
      }),
    });
    if (response.status !== 200) return ({ ok: false, error: response.status });
    const json = await response.json();
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
